import React from 'react';
import { Image, ScrollView, View } from 'react-native';
import useTranslation from '../../../hooks/translation-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import Label, { LabelType } from '../Label';
import CustomButton from '../CustomButton';

type Props = {
  message: string;
  onRetry(): void;
  onBack(): void;
};

const SurveyLoadErrorScreen = ({ message, onRetry, onBack }: Props) => {
  const t = useTranslation();
  const theme = useCustomTheme();
  return (
    <ScrollView style={{ flex: 1, backgroundColor: theme.background.primary as any }} contentContainerStyle={{ flexGrow: 1 }}>
      <View style={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: 24, paddingVertical: 32 }}>
        <Image style={{ width: 229, height: 274 }} source={require('../../../../assets/SurveyError.png')} />
        <Label variant={LabelType.titleLargeNoCapsPrimary} style={{ textAlign: 'center', fontWeight: '800', fontSize: 30, marginTop: 16 }}>
          {t('mission.survey-unavailable-title')}
        </Label>
        <View accessibilityRole="alert" style={{ width: '100%', maxWidth: 420, marginTop: 24 }}>
          <Label numberOfLines={0} style={{ textAlign: 'center', fontSize: 14, lineHeight: 20 }}>{message}</Label>
        </View>
        <View style={{ width: '100%', maxWidth: 320, gap: 12, marginTop: 24 }}>
          <CustomButton title={t('retry')} onPress={onRetry} />
          <CustomButton secondary title={t('my_missions')} onPress={onBack} />
        </View>
      </View>
    </ScrollView>
  );
};

export default SurveyLoadErrorScreen;
